// The intro preloader is a first-impression animation, not a route transition:
// it plays once per page load on the landing page and never again while the app
// is alive. Module scope (not sessionStorage) on purpose - a genuine fresh load
// of "/" must always play it, even if the visitor arrived via /blog first.
let hasPlayed = false;

export const shouldPlayPreloader = (pathname) => pathname === "/" && !hasPlayed;

export const markPreloaderPlayed = () => {
  hasPlayed = true;
};
